{
	"aiErase": "AI Erase",
	"aiGenerate": "AI Generate",
	"aiVariation": "AI variation {{var0}}",
	"aiEnhancedPromptDebug": "AI-enhanced prompt (debug)",
	"ariaAiEnhancedPromptDebug": "AI-enhanced prompt (debug)",
	"ariaDeleteHealing": "Delete Healing",
	"ariaExpandHealingMaskArea": "Expand Healing Mask Area",
	"ariaFixHealingEdgeMismatches": "Fix Healing Edge Mismatches",
	"ariaHealingPanel": "Healing Panel",
	"ariaNextAiVariation": "Next AI variation",
	"ariaPreviousAiVariation": "Previous AI variation",
	"brushSetting": "Brush Setting",
	"creditsRemaining_one": "{{count}} credit remaining",
	"creditsRemaining_other": "{{count}} credits remaining",
	"creditsUnavailable": "Credits unavailable",
	"describePlaceholder": "Describe the desired changes (e.g., 'Fix the wrinkles on the shirt')",
	"erase": "Erase",
	"erasing": "Erasing...",
	"expandMaskArea": "Expand Mask Area",
	"fixEdgeMismatches": "Fix Edge Mismatches",
	"generate": "Generate",
	"generating": "Generating...",
	"heal": "Heal",
	"loadingCredits": "Loading credits...",
	"outOfCredits": "You are out of Gen-AI credits",
	"pleaseBrushFirst": "Please brush an area to edit first",
	"pleaseEnterPrompt": "Please enter a prompt",
	"reErase": "Re-Erase",
	"reference": "Reference {{var0}}",
	"regenerate": "Regenerate",
	"removeReferenceImage": "Remove reference image",
	"subscriberCreditsTooltip": "Your 250 Gen-AI credits reset at the start of each month. Unused credits do not roll over.",
	"freeUserCreditsTooltip": "Your current plan includes 100 trial Gen-AI credits. Upgrade your account for more.",
	"selectedRemoval": "Selected Removal",
	"sendMaskDescription": "Send red mask overlay to AI to specify the editing area.",
	"sendMaskToAi": "Send mask to AI",
	"sliderBrushSize": "Brush Size",
	"sliderFeather": "Feather",
	"sliderOpacity": "Opacity",
	"tooltipAddReference": "Add images as reference (up to 2)",
	"variationLabel": "Variation {{index}}",
	"variationLimitReached": "Variation limit reached for this AI edit ({{max}} max)",
	"variationProgress": "{{current}} / {{total}}",
	"variations": "Variations"
}
